import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Box, Typography, Button, Tooltip } from '@material-ui/core'
import _ from 'lodash'
import Breadcrumb from '../../Components/Breadcrumbs'
import { useStyles } from './style'
import { TableOutline, Cards } from '../../elements'
import { systemsService } from '../../Services/SystemsService/SystemsService'
import { AppButton, DisplayMessage, Loader } from '../../Components'
import * as messageTypes from '../../utils/messageTypes'
import { mapKey } from '../../utils/googleMapKey'
import { tableHeadings, availableStatuses, STATUS, NONE } from './constant'
import Filters from './Filters'
import { COMMON } from '../../utils/constants'
import { userPreferenceService } from '../../Services/UserPreferenceService/UserPreferenceService'
import CustomDialog from '../../Components/CustomDialog'
import GoogleMap from 'google-map-react'
import { programService } from '../../Services'
import StatusButton from '../../Components/StatusButton'

const defaultColumns = ['SITE ID', 'SYSTEM NAME', 'BATTERY CAPACITY (kWh)', 'STATUS']
function Systems(props) {
  const classes = useStyles()
  const [tableRows, setTableRows] = useState([])
  const [allSystems, setAllSystems] = useState([])
  const [tableData, setTableData] = useState([])
  const [tableLoading, setTableLoading] = useState(true)
  const [loader, setLoader] = useState(false)
  const [filters, setFilters] = useState()
  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState('')
  const [messageType, setMessageType] = useState()
  const [page, setPage] = useState(1)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [totalCount, setTotalCount] = useState(0)
  const [columns, setColumns] = useState()
  const [openMap, setOpenMap] = useState(false)
  const [program, setProgram] = useState({})
  const [mapData, setMapData] = useState([])
  const programId = props?.match?.params?.programId
  const unchangedCol = ['BATTERY CAPACITY (kWh)', 'BATTERY POWER (kW)', 'COMMITTED POWER (kW)']

  const status = {
    [availableStatuses.APPLICATION_STARTED]: '#7ACF38',
    [availableStatuses.APPLICATION_SUBMITTED]: '#7ACF38',
    [availableStatuses.APPLICATION_REJECTED]: '#FF6565',
    [availableStatuses.ENROLLED]: '#7ACF38',
    [availableStatuses.UNENROLLED]: '#FF6565',
  }

  const handleTableHeadings = (rows) => {
    updateColumns(rows)
  }

  const resetDefault = () => {
    updateColumns([], defaultColumns)
  }

  const updateColumns = (rows, defaultColumns) => {
    const { currentUser } = props
    let columns = []
    rows.forEach(row => {
      columns.push(row.header)
    })
    columns = columns.map(column => column === 'ZIP/POSTAL CODE' ? 'ZIP' : column)
    setLoader(true)
    userPreferenceService.setPreference(currentUser.account_id, programId, 'system', { email: currentUser.id, user_preference_attributes: { "columns": columns.length > 0 ? columns : defaultColumns } })
      .then(preferenceData => {
        getAllColumns()
        setLoader(false)
      })
      .catch(error => {
        setLoader(false)
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })
  }

  const getAllSystems = () => {
    setLoader(true)
    setTableLoading(true)
    const { currentUser } = props
    let columns = []
    tableRows.forEach((row) => {
      columns.push(row.header)
    })
    columns = columns.map(column => column === 'ZIP/POSTAL CODE' ? 'ZIP' : column)
    let status = _.get(filters, 'tags.status.[0]', undefined)
    _.unset(filters, 'tags.status')
    const payload = { columns: columns, query: filters ? filters : undefined }

    systemsService
      .getAllSystems(currentUser.account_id, programId, payload, page - 1, rowsPerPage, status)
      .then((systemsData) => {
        setAllSystems(systemsData)
        setSystemsTable(systemsData)
        setTotalCount(systemsData.total_count)
        setLoader(false)
        setTableLoading(false)
      })
      .catch((error) => {
        setLoader(false)
        setTableLoading(false)
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })
  }

  const getStatus = (obj) => (
    <StatusButton text={obj} color={status[obj]} />
  )

  const setSystemsTable = (systemsData) => {
    let systemsTable = []
    systemsData.systems_info.map((object) => {
      let tableObj = []
      object.map((obj, index) => {
        tableObj.push({
          id: tableRows[index].id,
          value: tableRows[index].id === 'status' ? getStatus(obj) : obj || '--',
          handleClick: () => props.history.push({ pathname: `${props.location.pathname}/${obj}`, state: { siteId: obj, programId: programId } }),
          className: tableRows[index].id === 'battery capacity (kwh)' || tableRows[index].id === 'battery power (kw)' || tableRows[index].id === 'committed power (kw)' ? classes.tableCenterAlign : ''
        })
      })
      tableObj = tableObj.map(data => data.id === 'state' && data.value === NONE ? { ...data, value: '' } : data)
      systemsTable.push(tableObj)
    })

    setTableData(systemsTable)
  }

  const getAllColumns = () => {
    const { currentUser } = props
    setLoader(true)
    systemsService.getAllColumns(currentUser, programId)
      .then(columnsData => {
        setColumns(columnsData)
        columnsData.columns_to_be_shown = columnsData.columns_to_be_shown.map(column => column === 'ZIP' ? 'ZIP/POSTAL CODE' : column)
        columnsData.system_defined_fields = columnsData.system_defined_fields.map(column => column === 'ZIP' ? 'ZIP/POSTAL CODE' : column)
        columnsData.tags = columnsData.tags.map(column => column === 'ZIP' ? 'ZIP/POSTAL CODE' : column)
        let rows = []
        columnsData.columns_to_be_shown.forEach(column => {
          rows.push({ id: column.toLowerCase(), header: column, isLink: column === 'SITE ID', className: `${column.toLowerCase() === 'battery capacity (kwh)' ? classes.batteryCapacity : column.toLowerCase() === 'battery power (kw)' ? classes.batteryPower : column.toLowerCase() === 'committed power (kw)' ? classes.committedPower : ''} ${unchangedCol.includes(column) ? '' : classes.upperCaseHeadings}` })
        })
        setTableRows(rows)
        setLoader(false)
      })
      .catch(error => {
        setLoader(false)
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })
  }

  const getProgram = () => {
    const { currentUser } = props
    programService.getProgramsById(currentUser.account_id, programId)
      .then(programData => {
        setProgram(programData)
      })
      .catch(error => {
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })
  }

  const getMapDetails = () => {
    const { currentUser } = props
    setLoader(true)
    systemsService.getMapDetails(currentUser, programId)
      .then(mapData => {
        setLoader(false)
        setMapData(mapData)
        setOpenMap(true)
      })
      .catch(error => {
        setLoader(false)
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })
  }

  const Marker = (system) => {
    return (
      <Tooltip title={_.get(system, 'name.site_id', 'Site')} arrow>
        <div className={classes.mapMarker} >
        </div>
      </Tooltip>
    )
  }

  const handleFilters = (filter) => {
    setFilters({ tags: filter, operator: 'AND' })
  }

  const handleMessageClose = (event, reason) => {
    if (reason === COMMON.CLICKAWAY) {
      return
    }

    setOpen(false)
  }

  const handlePageChange = (newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (value) => {
    setRowsPerPage(value)
    setPage(1)
  }

  useEffect(() => {
    getProgram()
    getAllColumns()
  }, [])

  useEffect(() => {
    if (tableRows.length > 0)
      getAllSystems()
  }, [tableRows, filters, page, rowsPerPage])

  const renderSystemContent = () => (
    <>
      <Filters
        handleRows={handleTableHeadings}
        headings={tableRows}
        resetDefault={resetDefault}
        handleFilters={handleFilters}
        columns={columns}
      />
      <TableOutline
        tableHeadings={tableRows}
        tableData={tableData}
        totalElement={totalCount}
        loading={tableLoading}
        pagination={tableData.length > 0}
        page={page}
        rowsPerPage={rowsPerPage}
        handleChangePage={handlePageChange}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </>
  )

  const getMapContent = () => (
    <Box className={classes.mapWrapper}>
      <GoogleMap
        style={{ height: "600px" }}
        resetBoundsOnResize={true}
        defaultCenter={{ lat: _.get(mapData[0], 'latitude', 0), lng: _.get(mapData[0], 'longitude', 0) }}
        defaultZoom={5}
        apiKey={mapKey}
      >
        {mapData.map(map => (
          <Marker lat={map.latitude} lng={map.longitude} name={map} />
        ))}
      </GoogleMap >
    </Box>
  )

  const getBreadcrumbs = () => {
    let value = [{ 'Home': '/' }, { 'Programs': '/programs' }]
    if (program) {
      value.push({ [program?.program_name_admin_ui]: `/programs/${program.id}` })
      value.push({ 'Systems': `/programs/${program.id}/systems` })
    } else {
      value.push({ 'Systems': '' })
    }
    return value
  }

  return (
    <Box>
      <Loader loading={loader} />
      <Breadcrumb value={getBreadcrumbs()} />
      <DisplayMessage open={open} message={message} messageType={messageType} handleClose={handleMessageClose} />
      <CustomDialog open={openMap} title={`Systems Enrolled to ${_.get(program, 'program_name_admin_ui', 'Program Name')}`} content={getMapContent()} handleClose={() => setOpenMap(false)} fullWidth maxWidth="xl" />
      <Box className={classes.headerWrapper} display="flex" flexWrap="wrap">
        <Box>
          <Typography className={classes.title}>Systems</Typography>
        </Box>
        <Box className={classes.buttonContainer}>
          <AppButton className={`${classes.mr4} ${classes.buttons}`} fill={false} text="View Systems on Map" onClick={() => { getMapDetails() }} />
          <AppButton className={classes.buttons} text="Manage Tags" fill={false} onClick={() => props.history.push({ pathname: `/programs/${programId}/tags-manager`, state: { programId: programId } })} />
        </Box>
      </Box>
      <Cards className={classes.cardWrapper} children={renderSystemContent()} />
    </Box>
  )
}

const mapStateToProps = ({ auth }) => {
  const { authUser, currentUser } = auth
  return { authUser, currentUser }
}

export default connect(mapStateToProps, {})(Systems)
